import { useEffect } from "react";
import { useIdle } from "@uidotdev/usehooks";
import { supabase } from "@/integrations/supabase/client";

//24 hrs
const useIdleLogout = (
  idleTime = 24 * 60 * 60 * 1000,
  isAuthenticated = false
) => {
  const isIdle = useIdle(idleTime);

  useEffect(() => {
    // Only run idle logout if user is authenticated
    if (isIdle && isAuthenticated) {
      console.log("Auto-logout due to inactivity");
      supabase.auth.signOut().then(() => {
        //  Redirect to login
        window.location.href = "/login";
      });
    }
  }, [isIdle, isAuthenticated]);
};

export default useIdleLogout;
